import React from 'react'
import {Badge, Media} from 'reactstrap'

import CircleIcon from 'react-icons/lib/fa/circle'
import HalfCircleIcon from 'react-icons/lib/fa/exclamation-circle'
import BrokenCircleIcon from 'react-icons/lib/fa/times-circle'
import ArchiveIcon from 'react-icons/lib/fa/archive'
import PauseIcon from 'react-icons/lib/fa/pause'
import PlayIcon from 'react-icons/lib/fa/play'
import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'
import ServiceDisabledIcon from 'react-icons/lib/fa/times-circle-o'
import SubscriptionIcon from 'react-icons/lib/fa/bell'
import SubscriptionExpiredIcon from 'react-icons/lib/fa/bell-slash'
import SubscriptionNotPaidIcon from 'react-icons/lib/fa/bell-slash-o'

import SignalFiveBars from '../../images/signal-5.png'
import SignalFourBars from '../../images/signal-4.png'
import SignalThreeBars from '../../images/signal-3.png'
import SignalTwoBars from '../../images/signal-2.png'
import SignalOneBar from '../../images/signal-1.png'

let connectionIconForSignal = (cellServiceActive, connectionStrength) => {
    if (!cellServiceActive) {
        return <ServiceDisabledIcon className="text-danger"/>
    } else if (connectionStrength < 1 || connectionStrength > 105) {
        return <WarningIcon className="text-warning"/>
    } else if (connectionStrength < 70) {
        return <Media object src={SignalFiveBars} width="24px"/>
    } else if (connectionStrength < 77) {
        return <Media object src={SignalFourBars} width="24px"/>
    } else if (connectionStrength < 85) {
        return <Media object src={SignalThreeBars} width="24px"/>
    } else if (connectionStrength < 95) {
        return <Media object src={SignalTwoBars} width="24px"/>
    } else {
        return <Media object src={SignalOneBar} width="24px"/>
    }
}

let statusIconForController = (controller) => {
    if (controller.archived) {
        return <ArchiveIcon className="text-muted mr-1 ml-0 mr-sm-3"/>
    } else if (controller.missedHeartbeats > 0) {
        return <HalfCircleIcon className="text-warning mr-1 ml-0 mr-sm-3"/>
    } else if (controller.online) {
        return <CircleIcon className="text-success mr-1 ml-0 mr-sm-3"/>
    } else {
        return <BrokenCircleIcon className="text-danger mr-1 ml-0 mr-sm-3"/>
    }
}

let subscriptionIconForController = (controller) => {
    /*subscription_status
    0 = expired
    1 = trial
    2 = active
    3 = expiring
     */

    if (controller.archived) {
        return <span></span>
    }


    if (!controller.subscriptionStatus) {
        return <SubscriptionExpiredIcon className="text-danger mr-1 ml-0 mr-sm-3"/>
    } else if (controller.subscriptionStatus < 3) {
        return <SubscriptionIcon className="text-success mr-1 ml-0 mr-sm-3"/>
    } else if (controller.subscriptionStatus === 4) {
            return <SubscriptionNotPaidIcon className="text-warning mr-1 ml-0 mr-sm-3"/>
    } else {
        return <SubscriptionIcon className="text-warning mr-1 ml-0 mr-sm-3"/>
    }
}

let runStatusIconForController = (controller) => {
    if (controller.archived) {
        return <span></span>
    }

    return (controller.running ?
            <PlayIcon className="text-secondary"/> :
            <PauseIcon className="text-secondary"/>)
}

let statusTextForController = (controller) => {
    let runStatusText = (controller.running ? "Pump running" : "Pump stopped")
    let connStatusText = ""
    let subStatusText = ""

    if (controller.archived) {
        connStatusText = "controller archived"
    } else if (controller.missedHeartbeats > 0) {
        connStatusText = "controller has intermittent connectivity"
    } else if (controller.online) {
        connStatusText = "controller online"
    } else {
        connStatusText = "controller offline"
    }

    if (!controller.subscriptionStatus) {
        subStatusText = "subscription expired"
    } else if (controller.subscriptionStatus < 3) {
        subStatusText = "subscription active"
     }
     else if (controller.subscriptionStatus === 4) {
        subStatusText = "subscription not paid"
    }
     else {
        subStatusText = "subscription expiring soon"
    }

    return `${connStatusText}, ${runStatusText}, and ${subStatusText}`
}

let textForField = (field) => {
    let fieldText = ""
    if (field && field.field_number) {
        fieldText += `${field.field_number} `
    }
    if (field && field.name) {
        fieldText += `${field.name}`
    }
    if (fieldText.length < 1) {
        fieldText = "-"
    }
    return fieldText
}

let onSelectModel = (model,onSelectedChange, selectedControllers) => {
    let selected = selectedControllers ? [...selectedControllers] : []

    if (selected.includes(model.id)) {
        selected = selected.filter((m) => m !== model.id)
    } else {
        selected.push(model.id)
    }
    
    onSelectedChange(selected)
}


let ControllerListTableRow = ({controller, archivedOnlySelection, compact, deletearchivecontrollers, highlighted, sortBy, showTeam, onMouseOver, onMouseOut, onClick, selectable, onSelectedChange, selectedControllers}) =>
    <tr className={(highlighted ? "highlighted " : "") + "controller-table-item"}
        
        onMouseOver={onMouseOver ? (event => onMouseOver(event, controller)) : undefined}
        onMouseOut={onMouseOut ? (event => onMouseOut(event, controller)) : undefined}>
        {selectable && archivedOnlySelection ?
        <th width="100">
            <input type="checkbox"
                   disabled={!controller.archived}
                   checked={selectedControllers && selectedControllers.includes(controller.id)}
                   onChange={() => onSelectModel(controller, onSelectedChange, selectedControllers)}/>
        </th> : selectable && !controller.archived && !deletearchivecontrollers ?
        <th width="100">
            <input type="checkbox"
                                           checked={selectedControllers && selectedControllers.includes(controller.id)}
                                           onChange={() => onSelectModel(controller, onSelectedChange, selectedControllers)}/>
        </th> : deletearchivecontrollers && selectable  ?
        <th width="100"><input type="checkbox"
        checked={selectedControllers && selectedControllers.includes(controller.id)}
        onChange={() => onSelectModel(controller, onSelectedChange, selectedControllers)}/></th>:!deletearchivecontrollers ?<th width="100"><input type="checkbox" disabled/></th>:
        null}
        <td className="status-col" title={statusTextForController(controller)}>
            {statusIconForController(controller)}
            {runStatusIconForController(controller)}
            {subscriptionIconForController(controller)}
        </td>

        <td title={controller.userIdentifiableName}
        onClick={onClick ? (event => onClick(event, controller)) : undefined}>
            {controller.userIdentifiableName}
        </td>

        {showTeam ?
            <td title={controller.team ? controller.team.name : ""}>
                {controller.team ?
                    <span>{controller.team.name}</span> :
                    <strong>Unassigned</strong>}
            </td> :
            null}

        {!compact ? <td className="d-none d-md-table-cell" title={textForField(controller.field)}>
            {textForField(controller.field)}
        </td> : null}

        {!compact ? <td className="d-none d-md-table-cell">
            <Badge>
                {controller.running && controller.flowRate > 0 ?
                    <span>
                        {controller.flowRate}&nbsp;{controller.flowUnits}
                    </span> :
                    "No Flow"}
            </Badge>
        </td> : null}

        {!compact ? <td className="d-none d-lg-table-cell">
            {controller.tankIsLow || controller.tankLevel < 1 ?
                <Badge color="warning">
                    {controller.tankIsLow && controller.tankLevel > 0 ?
                        <span>LOW:&ensp;{controller.tankLevel}&nbsp;{controller.batchUnits || "GAL"}</span> :
                        <span>Empty</span>}
                </Badge> :
                <Badge>
                    {controller.tankLevel}&nbsp;{controller.batchUnits || "GAL"}
                </Badge>}
        </td> : null}


        <td className="d-none d-lg-table-cell">
            {controller.archived ? null : connectionIconForSignal(controller.cellServiceActive, controller.connectionStrength)}
        </td>
    </tr>

export default ControllerListTableRow



// WEBPACK FOOTER //
// ./src/components/ui/ControllerListTableRow.js